import { Component, HostListener, inject, signal } from '@angular/core';
import { TranslatePipe } from '../pipes/translate.pipe';
import { ErrorDialogService } from './error-dialog.service';

@Component({
  selector: 'app-error-dialog',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './error-dialog.html',
})
export class ErrorDialogComponent {
  protected readonly errorDialog = inject(ErrorDialogService);
  protected showDetails = signal(false);

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.errorDialog.data()) {
      this.close();
    }
  }

  protected close(): void {
    this.showDetails.set(false);
    this.errorDialog.clear();
  }

  protected onOverlayClick(event: MouseEvent): void {
    if ((event.target as HTMLElement).dataset['overlay']) {
      this.close();
    }
  }
}
